Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.BindControl, 'x-product-box', function (envelope) {

        var $context = envelope.message.data.context, model, quickBuyObj, $hoveredProduct, selectedSku, colorSelectorCallback = false,
            $boxes = $('.x-product-box', $context);

        if ($boxes.length < 1)
            return;

        if (!isTouch()) {
            initProducboxHover($boxes); 
        }

        if ($('.takeaway-price-container', $boxes).length > 0) {
            $('.takeaway-price-container', $boxes).each(function () {
                initTakeAwayPrice($(this));
            });
        }

        $boxes.on('click', '.js-remove-from-cart', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this), $box, cartIds;

            $box = $this.closest('.x-product-box');

            cartIds = $box.prop('data-cartproductid');

            Vendd.MessageBus.publishAsync($box.get(0), new Vendd.Cart.Messages.MultipleRemove(cartIds));

            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.MultipleRemoveSuccess, $box, function (envelope) {
                $this.attr('disabled', 'disabled').parent().addClass('disabled');
                toastr.success(envelope.message.data.data.SuccessMessage, "", { timeOut: 1200, showDuration: 1000, hideDuration: 700 });
                Vendd.MessageBus.unsubscribe(Vendd.Cart.Messages.MultipleRemoveSuccess, $box);
            });
        });

        $boxes.on('click', '.js-add-to-cart', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this),
                $box, $qty,
                id, skuId, path, qty, extraAttributes, bundleItems, color, colorId, size, $wrapper, list, recipeItems, comboItems;

            if ($this.hasClass('x-disabled') || $this.is(':disabled'))
                return;
            if ($('.x-warehouse-selector-widget').trigger('addtocart').hasClass('opening'))
                return;

            $box = $this.closest('.x-product-box');
            $qty = $('.js-qty', $box);

            id = $box.data('productid');
            skuId = $box.data('variantid');
            var defaultcolorId = $box.data('default-colorid');

            path = $box.data('path');
            qty = ($qty.val() ? stringToNumber($qty.val()) : null) || 1;
            extraAttributes = [];
            bundleItems = [];
            recipeItems = [];
            comboItems = [];

            var itemInfo = {
                minQuantity: parseInt($box.data('min-quantity') || 0),
                maxQuantity: parseInt($box.data('max-quantity') || 0),
                quanta: parseInt($box.data('quanta') || 0)
            };

            //enhanced info
            color = $box.attr('data-color');
            size = $box.attr('data-size');
            colorId = $box[0].SelectedColorId || defaultcolorId || 0;

            $wrapper = $this.closest('.x-control.x-product-list');
            list = $wrapper.data('list');

            var enhancedInfo = { color: color, size: size, list: list, colorId: colorId };
            //enhanced info

            Vendd.MessageBus.publishAsync($box.get(0), new Vendd.Cart.Messages.Add(id, skuId, path, qty, extraAttributes, bundleItems, recipeItems, comboItems, itemInfo, enhancedInfo));
            //Open the widget only for template 1 of Cart Widget
            if ($('.x-cart-widget').data('template') === 1) {
                if ($box.closest('.x-searchbox.elastic').length > 0) {
                    toastr.success(LhApp.Function.getText("Common:ProductAddedToCart"), "", { timeOut: 1200, showDuration: 300, hideDuration: 700 });
                } else {
                    Vendd.MessageBus.publishAsync($wrapper, new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.CartWidget, false));
                }
            }

        });

        $boxes.on('click', '.js-remove-from-wishlist', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this), $box, wishlistItemId;

            if ($this.closest('.wishlist-button').hasClass('x-disabled'))
                return;

            $box = $this.closest('.x-product-box');

            if ($box.data('hasquickbuy')) {
                var varId = parseInt($box.data('variantid'));
                var wishlistModel = JSON.parse(localStorage.getItem("CurrentWishlistModel"));
                var selectedsku = wishlistModel.Items.find(function (item) { return varId === item.VariantId });
                wishlistItemId = selectedsku.Id;
            } else {
                wishlistItemId = $box.prop('data-wishlistitemid');
            }

            Vendd.MessageBus.publishAsync($box.get(0), new Vendd.Wishlist.Messages.Remove(wishlistItemId));
        });

        $boxes.on('click', '.js-add-to-wishlist', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this),
                $box, $qty,
                id, skuId, path, qty, extraAttributes, bundleItems;

            if ($this.closest('.wishlist-button').hasClass('x-disabled'))
                return;

            $box = $this.closest('.x-product-box');
            $qty = $('.js-qty', $box);

            id = $box.data('productid');
            skuId = $box.data('variantid');
            path = $box.data('path');
            qty = ($qty.val() ? stringToNumber($qty.val()) : null) || 1;
            extraAttributes = [];
            bundleItems = [];

            if (LhApp.Context.MultipleWishlistsEnabled && $('.x-user-wishlists', $box).length > 0) {
                UserWishlist.HideAllProductWishlists();
                UserWishlist.ShowProductWishlists($('.x-user-wishlists', $box).get(0));
            } else {
                Vendd.MessageBus.publishAsync($box.get(0), new Vendd.Wishlist.Messages.Add(id, skuId, path, qty, extraAttributes, bundleItems));
            }
        });

        $boxes.on('click', '.js-remove-from-compare', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this), $box, productId;

            if ($this.closest('.compare-button').hasClass('x-disabled'))
                return;

            $box = $this.closest('.x-product-box');

            productId = $box.prop('data-productid');

            Vendd.MessageBus.publishAsync($box.get(0), new Vendd.ProductCompare.Messages.Remove(productId));

            if ($('.x-productcompare-widget').data('template') === 1) {
                Vendd.MessageBus.publishAsync($box.get(0), new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.ProductCompareWidget, false));
            }
        });

        $boxes.on('click', '.js-add-to-compare', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this),
                $box, $qty,
                id, skuId, path, qty;

            if ($this.closest('.compare-button').hasClass('x-disabled'))
                return;

            $box = $this.closest('.x-product-box');
            $qty = $('.js-qty', $box);

            id = $box.data('productid');
            skuId = $box.data('variantid');
            path = $box.data('path');
            qty = ($qty.val() ? stringToNumber($qty.val()) : null) || 1;

            Vendd.MessageBus.publishAsync($box.get(0), new Vendd.ProductCompare.Messages.Add(id, skuId));

            if ($('.x-productcompare-widget').data('template') === 1) {
                Vendd.MessageBus.publishAsync($box.get(0), new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.ProductCompareWidget, false));
            }
        });

        $boxes.on('click', '.js-qty-change', function (e) {
            var $this, $spinner, $input, $box, val, min, max, step;

            $this = $(this);
            $spinner = $this.parent();
            $input = $this.siblings('input[name="qty"]').eq(0);
            $box = $this.closest($boxes);
            val = parseFloat($input.val()).toFixed(2);
            min = $(this).closest("article").attr("data-min-quantity");
            max = $(this).closest("article").attr("data-max-quantity");
            step = $(this).closest("article").attr("data-quanta");

            if ($spinner.hasClass('x-disabled'))
                return;

            if ($this.hasClass('js-decrement')) {

                if (min === "" && max === "" && step === "") {
                    min = parseInt($spinner.data('min'));
                    max = parseInt($spinner.data('max'));
                    step = parseInt($spinner.data('step'));

                    if ((parseInt(val) - parseInt(step)) <= parseInt(min)) {
                        val = parseInt(min);
                    } else {
                        val = parseInt(val) - parseInt(step);
                    }                  
                }
                else if (Vendd.Helpers.isInteger(parseFloat(step))) {
                    val = parseInt(val) - parseInt(step);
                }
                else if (parseFloat(val) > parseFloat(min) && (parseFloat(val) - parseFloat(step) >= parseFloat(min))) {
                    val = parseFloat(val) - parseFloat(step);
                    val = parseFloat(val).toFixed(2);
                }

                $input.val(val);
                $this.siblings('.js-increment').removeClass('disabled');
                $this.siblings('.js-increment').removeAttr('disabled');

                if (val === min) {
                    $this.addClass('disabled');
                    $this.attr('disabled', 'disabled');
                }
            } else if ($this.hasClass('js-increment')) {

                if (min === "" && max === "" && step === "") {
                    min = parseInt($spinner.data('min'));
                    max = parseInt($spinner.data('max'));
                    step = parseInt($spinner.data('step'));
                    val = parseInt(val) + parseInt(step);
                }
                else if (Vendd.Helpers.isInteger(parseFloat(step))) {
                    val = parseInt(val) + parseInt(step);
                }
                else if (parseFloat(val) < parseFloat((max == null || max === "" || max <= 0 ? 1000000 : max)) && (parseFloat(val) + parseFloat(step)) <= parseFloat((max == null || max === "" || max <= 0 ? 1000000 : max))) {
                    val = parseFloat(val) + parseFloat(step);
                    val = parseFloat(val).toFixed(2);
                }

                $input.val(val);
                $this.siblings('.js-decrement').removeClass('disabled');
                $this.siblings('.js-decrement').removeAttr('disabled');

                if (val === max) {
                    $this.addClass('disabled');
                    $this.attr('disabled', 'disabled');
                }
            }

            updateQuantityPrice($box);
        });

        $boxes.on('keydown', '.js-qty', function (e) {
            numbersOnly(e);
        });

        $boxes.on('click', '.js-select-product', function (e) {

            var $this, $box, id, $wrapper, list;
            $this = $(this);

            $box = $this.closest('.x-product-box');

            id = $box.data('productid');

            $wrapper = $this.closest('section.x-product-list');
            list = $wrapper.data('list');

            Vendd.MessageBus.publish($box.get(0), new Vendd.Product.Messages.ProductSelected(id, list));
        });

        $boxes.on('click', '.js-color-selector', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this);
            var $box = $this.closest($boxes);

            if (!$box.data('hascolorselector'))
                return;

            //get selected color data
            var selectedColorId = $this.data('id');
            var selectedColorName = $this.data('name');
            var selectedColorSrc = $this.data('src');

            $('.js-color-selector', $box).removeClass('selected');
            $this.addClass('selected');

            //change product box image
            if (typeof selectedColorSrc != 'undefined') {
                $box.attr('data-color', selectedColorName);
                $box.attr('data-selected-colorid', selectedColorId);
                if (selectedColorId) {
                    var colorImages = jsonArr.find(function (product) { return product.Id == $box.attr('data-productid'); }).ColorImages.find(function (color) { return color.id == selectedColorId; }).images;
                    var imageCont = $('.image-container .js-product-link', $box);
                    if (typeof colorImages != 'undefined' && colorImages[1]) {
                        imageCont.html('<img class="image-one" src="' + colorImages[0] + '">');
                        imageCont.append('<img class="image-two" src="' + colorImages[1] + '">');
                    } else if (typeof selectedColorSrc != 'undefined') {
                        imageCont.html('<img src="' + selectedColorSrc  + '">');
                    }
                }
            } 

            //add the selected sku parameter in product box links
            addSkuParameterInProductBox($box, selectedColorId);     

            //sync color selector with quick buy - only if quickbuy is open
            if ($box.data('hasquickbuy') && $box.hasClass('x-initialized')) {
                colorSelectorCallback = true;
                $('.js-dimensions li[data-id=' + selectedColorId + ']', $box).trigger('click');
            }
        });

        $boxes.on('click', '.js-quick-view', function (e) {
            e.preventDefault();
            e.stopPropagation();
           // if (isTouch()) {
             //   window.location.href = $('> a', $(this).closest('.image-container')).attr('href');
               // return;
            //}
            var $this = $(this),
                $box, $qty,
                id, skuId, path, qty, extraAttributes, bundleItems;

            $box = $this.closest('.x-product-box');
            $qty = $('.js-qty', $box);

            id = $box.data('productid');
            skuId = $box.data('variantid');
            path = $box.data('path');
            qty = ($qty.val() ? stringToNumber($qty.val()) : null) || 1;
            extraAttributes = [];
            bundleItems = [];
            lang = LhApp.Context.Language;

            var Href = '/pages/productdetailspopup.aspx?iid=' + id + '&path=' + path + '&Quantity=' + qty + '&lang=' + lang;
            $.fancybox.open({
                src: Href,
                type: 'iframe',
                margin: [20, 0],
                toolbar  : false,
                iframe : { css:{ width : '900px', height : '550px' } }, 
                smallBtn : true,
                beforeShow: function () { 
                    var $fancyboxContainer = $('.fancybox-container');
                    $fancyboxContainer.addClass('product-details-popup');
                    var fancy = $('.fancybox-iframe');
                    fancy.closest('.fancybox-skin').addClass('quick-view');
                    fancy.contents().find('html').addClass('quick-view');
                    fancy.contents().find('.fancybox-my-close').on('click', function () { $.fancybox.close(); });
                    this.width = ($('.fancybox-iframe').contents().find('.product-details-popup').width());
                    this.height = ($('.fancybox-iframe').contents().find('html').height());
                },
                afterClose: function () {
                    window.lhSdriveTracking.sendPreviousView();
                }
            });
        });

        $boxes.on('click', '.js-set-delivery-point', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this), $box, deliveryPointId;

            $box = $this.closest('.x-product-box');

            deliveryPointId = $this.data('id');

            $('.js-set-delivery-point').addClass('x-disabled').attr('disabled', 'disabled').parent().addClass('x-loading');

            Vendd.MessageBus.publishAsync($box.get(0), new Vendd.Cart.Messages.SetDeliveryPoint(deliveryPointId));
        });

        if ($('.product-list-page').length > 0 || $('.search-products-page').length > 0 || $('.manufacturer-product-list').length > 0) {
            $boxes.on('click', '.js-product-link', function (e) {
                var $this = $(this), $box, id, url;

                $box = $this.closest('.x-product-box');

                if ($box.closest('.x-main-product-list').length < 1)
                    return;

                //add class to product list
                $box.closest('.x-product-list').addClass('js-redirecting');

                //get product id and page number
                id = $box.data('productid');
                pageNumber = $box.closest('li').data('page');

                //add product id and page to session storage
                sessionStorage.setItem('scrollToProductId', id);

                //manipulate state based on page number
                var querystring = window.location.pathname + (window.location.pathname.slice(-1) != "/" ? "/" : ""),
                    pageText = pageNumber > 1 ? "p" + pageNumber + "/" : "";

                if (!(/\/P\d+\//i.test(querystring))) {
                    querystring = querystring + pageText;
                } else {
                    querystring = querystring.replace(/\/P\d+\//i, "/" + pageText);
                }

                var url = window.location.protocol
                    + "//"
                    + window.location.host
                    + querystring
                    + window.location.search;

                if (window.location.href !== url)
                    history.replaceState({}, jQuery(document).find('title').text() + pageNumber, url);
            });
        }
       
        $boxes.on('click', '.js-quick-buy', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this);
            var $box = $this.closest($boxes);

            if (!$box.data('hasquickbuy'))
                return;

            $boxes.removeClass('shown');
            $box.addClass('shown');

            if (!$box.hasClass('x-initialized')) {
                initQuickBuy($box);
            }
        });

        function initQuickBuy($wrapper) {        

            var wrapper = $wrapper.get(0);
            var userModel = {}, showPriceWithoutVat = false;

            wrapper.productId = $wrapper.data('productid');
            wrapper.defaultColor = $wrapper.data('default-colorid');
            wrapper.selectedColor = $wrapper.data('selected-colorid');

            var state = Vendd.Quickbuy.initState(wrapper.productId, wrapper.defaultColor);

            if (state == undefined) return;

            wrapper.model = state;
            wrapper.dimensionWidget = $('.x-dimensions-widget', $wrapper);
            wrapper.quantitySelector = $('.x-cart-qty-spinner', $wrapper);
            wrapper.cartButton = $('.add-to-cart', $wrapper);
            wrapper.wishlistButton = $('.wishlist-button', $wrapper);
            wrapper.compareButton = $('.compare-button', $wrapper);
            wrapper.priceElement = $('.current-price', $wrapper);
            wrapper.deletedPriceElement = $('.deleted-price', $wrapper);
            wrapper.discountPercentageElement = $('.discount-percentage', $wrapper);
            wrapper.discountValueElement = $('.discount-value', $wrapper);
            wrapper.image = $('.image-container', $wrapper).find('img');

            if (!state.HasColors && !state.HasSizes && !state.HasDim3) {
                wrapper.cartButton.removeClass('x-disabled').find('button').prop("disabled", false);
                wrapper.quantitySelector.removeClass('x-disabled');
                wrapper.wishlistButton.removeClass('x-disabled');
                wrapper.compareButton.removeClass('x-disabled');

                return;
            }

            if (state.HasSingleDim) $wrapper.addClass('has-one-dim');
            if (state.HasTwoDims) $wrapper.addClass('has-two-dims');
            if (state.HasThreeDims) $wrapper.addClass('has-three-dims');

            //check color selector for new state
            if ($wrapper.data('hascolorselector') && $('.js-color-selector.selected', $wrapper).length > 0) {
                state.createNewColorState = true;
                if (wrapper.defaultColor === wrapper.selectedColor) {
                    state.defaultDimId = wrapper.defaultColor;
                } else {
                    state.defaultDimId = wrapper.selectedColor;
                }
            }

            //create new state
            if (state.createNewColorState) {
                Vendd.Quickbuy.createNewState(wrapper, state.defaultDimId, wrapper.productId, wrapper.defaultColor, 'color');
            } else if (state.createNewSizeState) {
                Vendd.Quickbuy.createNewState(wrapper, state.defaultDimId, wrapper.productId, wrapper.defaultColor, 'size');
            } else if (state.createNewDim3State) {
                Vendd.Quickbuy.createNewState(wrapper, state.defaultDimId, wrapper.productId, wrapper.defaultColor, 'dim3');
            }

            wrapper.GetUserModel = function () {
                userModel = Vendd.User && Vendd.User.GetClientModel();

                if (userModel) {
                    userModel = { ...userModel, ...{ ClientEnhancedModel: window.LhApp.ClientEnhancedModel } }; // model to be expanded from page html (window.LhApp = window.LhApp || {}; window.LhApp.ClientEnhancedModel = window.LhApp.ClientEnhancedModel || {}; 
                    showPriceWithoutVat = userModel.ShowPriceWithoutVat;
                }
            };

            wrapper.UpdateBoxData = function (type, imgSrc) {
                var $wrapper = $(this);
                                
                var selectedColorId = (typeof wrapper.SelectedColorId != 'undefined') ? wrapper.SelectedColorId : null;
                var selectedSizeId = (typeof wrapper.SelectedSizeId != 'undefined') ? wrapper.SelectedSizeId : null;
                var selectedDim3Id = (typeof wrapper.SelectedDim3Id != 'undefined') ? wrapper.SelectedDim3Id : null;

                if (selectedColorId && type === 'color') {
                    var colorImages = jsonArr.find(function (product) { return product.Id == wrapper.productId; }).ColorImages.find(function (color) { return color.id == selectedColorId; }).images;
                    var imageCont = $('.image-container .js-product-link', $wrapper);
                    if (typeof colorImages != 'undefined' && colorImages[1]) {
                        imageCont.html('<img class="image-one" src="' + colorImages[0] + '">');
                        imageCont.append('<img class="image-two" src="' + colorImages[1] + '">');
                    } else if (typeof imgSrc != 'undefined') {
                        imageCont.html('<img src="' + imgSrc + '">');
                    }
                }

                if ((wrapper.model.HasColors && !state.HasSingleColor && selectedColorId == null)
                    || (wrapper.model.HasSizes && !state.HasSingleSize && selectedSizeId == null)
                    || (wrapper.model.HasDim3 && !state.HasSingleDim3 && selectedDim3Id == null))
                {
                    wrapper.cartButton.addClass('x-disabled').find('button').prop("disabled", true);
                    wrapper.quantitySelector.addClass('x-disabled');
                    wrapper.wishlistButton.addClass('x-disabled');
                    wrapper.compareButton.addClass('x-disabled');
                    
                    return;
                }
                   
                selectedSku = Vendd.Quickbuy.GetSkuData(wrapper, wrapper.productId, wrapper.defaultColor, selectedColorId, selectedSizeId, selectedDim3Id);

                if (selectedSku !== null && typeof selectedSku !== "undefined") {
                    var skuData = selectedSku.SkuData;

                    $wrapper.data('variantid', skuData.SkuId);

                    if (!(skuData.CanBuy || skuData.CanPreorder)) {
                        wrapper.cartButton.addClass('x-disabled').find('button').prop("disabled", true).prev('.availability').html(skuData.NoAvailabilityName);
                        wrapper.quantitySelector.addClass('x-disabled');
                    } else {
                        wrapper.cartButton.removeClass('x-disabled').find('button').prop("disabled", false).prev('.availability').html(skuData.NoAvailabilityName);
                        wrapper.quantitySelector.removeClass('x-disabled');
                    }

                    var wishlistModel = JSON.parse(localStorage.getItem("CurrentWishlistModel"));

                    if (wishlistModel) {
                        var selectedsku = wishlistModel.Items.find(function (item) { return skuData.SkuId === item.VariantId });
                        var $wishlistButton = $('.wishlist-button', $wrapper);
                        if (selectedsku) {
                            $wishlistButton.addClass('already-in-wishlist');
                            $('.js-add-to-wishlist', $wishlistButton).addClass('disabled');
                            $('.js-remove-from-wishlist', $wishlistButton).removeClass('disabled');
                        } else {
                            $wishlistButton.removeClass('already-in-wishlist');
                            $('.js-add-to-wishlist', $wishlistButton).removeClass('disabled');
                            $('.js-remove-from-wishlist', $wishlistButton).addClass('disabled');
                        }
                    }

                    wrapper.wishlistButton.removeClass('x-disabled');
                    wrapper.compareButton.removeClass('x-disabled');

                    if (skuData.QuantityPrices) {
                        var quantity = parseInt($('input', wrapper.quantitySelector).val());
                        var quantityPrice = skuData.QuantityPrices.find(function (x) {  return quantity >= x.From.Value && quantity <= x.To.Value; });

                        skuData.UnitPrice = quantityPrice.Price.DisplayTotalValue;
                    }

                    if ($enableFormatPrices) {
                        if (!wrapper.priceElement.hasClass('price-formatted')) {
                            wrapper.priceElement.addClass('price-formatted');
                        }
                        wrapper.priceElement.html(formatPrice(skuData.UnitPrice));
                    } else {
                        wrapper.priceElement.text(skuData.UnitPrice);
                    }

                    if (skuData.DeletedPrice) {
                        wrapper.deletedPriceElement.text(skuData.DeletedPrice);
                    }

                    wrapper.discountPercentageElement.text(skuData.DiscountPercentage);
                    wrapper.discountValueElement.text(skuData.DiscountValue);

                }
            };

            $wrapper.on('click', '.js-dimensions li', function (e) {

                var $this = $(this), id, type, name, $wrap, wrapper, productId, defaultColor, imgSrc,
                    isColorList, isSizeList, isDim3List, $color, $size;

                if ($this.hasClass('selected') || $this.hasClass('disabled'))
                    return;

                id = $this.data('id');
                name = $this.data('name');
                type = $this.closest('.dropdown-content').data('type');

                isColorList = ($this.parent().hasClass('colors-list')) ? true : false;
                isSizeList = ($this.parent().hasClass('sizes-list')) ? true : false;
                isDim3List = ($this.parent().hasClass('dim3-list')) ? true : false;

                if (isColorList) imgSrc = $this.find('img').attr('src');

                $wrap = $this.closest('.x-product-box');
                wrapper = $wrap.get(0);
                productId = $wrap.data('productid');
                defaultColor = $wrap.data('default-colorid');

                $this.addClass('selected').siblings().removeClass('selected');
                $this.closest('.dropdown-list').find('.selected-text').html(name);

                if (id === undefined) return;

                var state = Vendd.Quickbuy.createNewState(wrapper, id, productId, defaultColor, type);
                Vendd.Quickbuy.Update(wrapper.dimensionWidget, state, "productDimensions_A");

                if (isColorList) {
                    wrapper.UpdateBoxData("color", imgSrc);
                    $wrap.attr('data-color', name);
                } else if (isSizeList) { 
                    wrapper.UpdateBoxData("size", imgSrc);
                    $wrap.attr('data-size', name);
                } else if (isDim3List) {
                    wrapper.UpdateBoxData("dim3", imgSrc);
                    $wrap.attr('data-dim3', name);
                }

                //sync quick buy with color selector
                if ($wrapper.data('hascolorselector') && isColorList && !colorSelectorCallback) {
                    $('.js-color-selector', $wrap).removeClass('selected');
                    $('.js-color-selector[data-id=' + id + ']', $wrap).addClass('selected');

                    addSkuParameterInProductBox($wrap, id, state); 
                }

                colorSelectorCallback = false;
            });

            $wrapper.on('click', '.js-dropdown-btn', function (e) {
                var $this = $(this);

                if ($this.hasClass('disabled')) return;

                if ($this.hasClass('expanded')) {
                    $this.removeClass('expanded');
                } else {
                    $('.js-dropdown-btn.expanded').removeClass('expanded');
                    $this.addClass('expanded');
                }
            });

            $(document).click(function (event) {
                if (!$(event.target).closest('.js-dropdown-btn').length &&
                    !$(event.target).is('.js-dropdown-btn')) {

                    $('.js-dropdown-btn').removeClass("expanded");
                }
            });

            $wrapper.closest('.x-product-list').on('mouseleave', function (e) {
                $('.x-product-box.hovered').removeClass('hovered');
                $('.js-dropdown-btn.expanded').removeClass('expanded');
            });

            Vendd.Quickbuy.Update(wrapper.dimensionWidget, state, "productDimensions_A");

            wrapper.GetUserModel();

            wrapper.UpdateBoxData();

            $wrapper.addClass('x-initialized');
        }

        function initProducboxHover($boxes) {
            if ($boxes.length == 0)
                return;

            var $quickBuyBoxes = $boxes.filter(function () {
                return $(this).data('hasquickbuy');
            });

            var config = {
                sensitivity: 50,
                interval: 180,
                over: mouseenter,
                timeout: 10,
                out: mouseleave
            };

            function mouseenter() {
                $this = $(this);
                if (!isTouch()) {
                    $this.closest('ul').find('.x-product-box').removeClass('hovered');
                    $this.addClass('hovered');
                }
            }

            function mouseleave() {
                return;
            }

            $quickBuyBoxes.hoverIntent(config);
        }

        function initTakeAwayPrice($productBox) {
            if ($productBox.length == 0)
                return;

            var takeawayprice = $('.takeaway-price', $productBox).text();
            if (takeawayprice != "") {
                $('.takeaway-price', $productBox).text(LhApp.Function.renderPrice(parseFloat(takeawayprice)));
            }
        }

        function updateQuantityPrice($wrapper) { 

            var skuId = $wrapper.data('variantid'), skuData;

            //if selectedSku already initialized from quick buy
            if (selectedSku !== null && typeof selectedSku !== "undefined") {
                skuData = selectedSku.SkuData;
            } else {
                selectedSku = window.jsonArr.find(function (x) { return x.Id = skuId; });
                skuData = selectedSku.FinalSkuPrices[skuId];
            }

            if (skuData && skuData.QuantityPrices) {
                var quantity = parseInt($('.x-cart-qty-spinner input', $wrapper).val());
                var quantityPrice = skuData.QuantityPrices.find(function (x) { return quantity >= x.From.Value && quantity <= x.To.Value; });
                var unitPrice = quantityPrice.Price.DisplayTotalValue;

                $('.current-price', $wrapper).text(unitPrice);
            }
        }
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, 'x-product-box', function (envelope) {
        var model = envelope.message.data.Cart;

        var $boxes = $('.x-product-box');

        if ($boxes.length < 1)
            return;

        $boxes.each(function (i, el) {
            var $el = $(el);
            var productId = $el.data('productid');
            var variantId = $el.data('variantid');
            var quantityInCart = 0, idsInCart = [], inCart = false;

            $el.find('.js-remove-from-cart').attr('disabled', 'disabled').parent().addClass('disabled');

            for (var j = 0; j < model.Items.length; j++) {
                if (productId == model.Items[j].ProductId) {
                    if (window.jsonArr) {
                        var list = window.jsonArr.find(function (list) {
                            return list.Id == productId && contains(list.SkuList, model.Items[j].VariantId) && contains(list.SkuList, variantId);
                        });
                        if (list) {
                            quantityInCart += model.Items[j].Quantity;
                            idsInCart.push(model.Items[j].Id);
                            inCart = true;
                        }
                    }
                }
            }

            if (inCart) {
                $el.prop('data-cartproductid', idsInCart);
                $el.find('.js-remove-from-cart').removeAttr('disabled').parent().removeClass('disabled');
                if (!model.CountAsOneInCart) $el.find('.js-cart-quantity').text("(" + quantityInCart + ")");
            }
        });
    });

    Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.Changed, 'x-product-box', function (envelope) {
        var data = envelope.message.data.Items;
        var $boxes = $('.x-product-box');

        if ($boxes.length < 1)
            return;

        $boxes.each(function (i, el) {
            var $el = $(el);
            var id = $el.data('variantid');

            if (data) {
                var productInWishlist = data.find(function (x) { return id === x.VariantId });
                var $wishlistButton = $('.wishlist-button', $el);

                if (productInWishlist) {
                    $el.prop('data-wishlistitemid', productInWishlist.Id);
                    $wishlistButton.addClass('already-in-wishlist');
                    $('.js-add-to-wishlist', $wishlistButton).addClass('disabled');
                    $('.js-remove-from-wishlist', $wishlistButton).removeClass('disabled');
                } else {
                    $wishlistButton.removeClass('already-in-wishlist');
                    $('.js-add-to-wishlist', $wishlistButton).removeClass('disabled');
                    $('.js-remove-from-wishlist', $wishlistButton).addClass('disabled');
                }
            }

        });

    });

    Vendd.MessageBus.subscribe(Vendd.ProductCompare.Messages.GetWidgetModelSuccess, 'x-product-box', function (envelope) {
        var data = envelope.message.data.model.Items;
        var $boxes = $('.x-product-box');

        if ($boxes.length < 1)
            return;

        $boxes.each(function (i, el) {
            var $el = $(el);
            var id = $el.data('productid');

            if (data) {
                var productInCompare = data.find(function (x) { return id === x.Id });
                var $compareButton = $('.compare-button', $el);

                if (productInCompare) {
                    $el.prop('data-productid', productInCompare.Id);
                    $compareButton.addClass('already-in-compare');
                    $('.js-add-to-compare', $compareButton).addClass('disabled');
                    $('.js-remove-from-compare', $compareButton).removeClass('disabled');
                } else {
                    $compareButton.removeClass('already-in-compare');
                    $('.js-add-to-compare', $compareButton).removeClass('disabled');
                    $('.js-remove-from-compare', $compareButton).addClass('disabled');
                }
            }

        });

    });

});

//function used in productBox_A.js and productList_A.js
function addSkuParameterInProductBox($productBox, selectedColorId, state) {

    if ($productBox.length < 1) return;

    var productBox = $productBox.get(0);

    //get product box data
    var productId = $productBox.data('productid');
    var variantId = $productBox.data('variantid');
    var defaultColor = $productBox.data('default-colorid');
    var $link = $productBox.data('url');
    var query = ($link.indexOf('?') > -1) ? '&' : '?';

    var $selectedSkuLink;

    if (defaultColor === selectedColorId) {
        //add data attribute
        $productBox.attr('data-selected-sku', variantId);
        //add sku parameter in product box links
        $selectedSkuLink = $link + (($link.indexOf('skuid=') === -1) ? query + 'skuid=' + variantId : '');
        $('.js-product-link', $productBox).attr('href', $selectedSkuLink);
    } else {
        //get quickbuy model
        var state = state ? state : Vendd.Quickbuy.initState(productId, defaultColor);
        if (!state) return;

        //find first available size of selected color
        var selectedColorModel = state.Colors.find(function (x) { return x.Id === selectedColorId });
        var defaultSizeId = selectedColorModel ? selectedColorModel.AvailableSizes[0] : null;

        //get selected sku of selected color
        productBox.model = state;
        var selectedSku = Vendd.Quickbuy.GetSkuData(productBox, productId, defaultColor, selectedColorId, defaultSizeId);
        if (selectedSku !== null && typeof selectedSku !== 'undefined') {
            //add data attribute
            $productBox.attr('data-selected-sku', selectedSku.SkuData.SkuId);
            //add sku parameter in product box links
            $selectedSkuLink = $link + (($link.indexOf('skuid=') === -1) ? query + 'skuid=' + selectedSku.SkuData.SkuId : '');
            $('.js-product-link', $productBox).attr('href', $selectedSkuLink);
        }
    }
}